import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/promo/components/common/DangerouslyHtml/DangerouslyHtml';
import { PromoInfoPage } from 'apps/promo/components/common/PromoInfoPage/PromoInfoPage';
import {
    LOW_RISK_UPGRADE_LIMIT_SCREEN,
    REACHING_LIMIT_SCREEN,
    UPGRADE_LIMIT_SCREEN,
    WAITING_SCREEN,
} from 'apps/promo/components/sharedComponents/status/Constants';
import PromoLowRiskUpgradeLimit from 'apps/promo/components/sharedComponents/status/PromoLowRiskUpgradeLimit';
import PromoReachingLimit from 'apps/promo/components/sharedComponents/status/PromoReachingLimit';
import PromoUpgradeLimit from 'apps/promo/components/sharedComponents/status/PromoUpgradeLimit';
import { AUTH_MY_CARDS_URL, AUTH_PROFILE_INVITE, AUTH_SEND_MAIN_LINK } from 'apps/promo/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/promo/hooks/selectors';

const Success = (props) => {
    const { headerTitle, statusText, statusSmsTitle, statusDoneTitle } = usePageMessages();
    const { cardPan, showLowRiskLimitIncrease } = useExtra();
    const [screen, setScreen] = useState(WAITING_SCREEN);

    const getPrimaryButtonLink = () => {
        if (props.status?.showUpgradeLimitPromo) {
            return '#';
        } else if (cardPan) {
            return AUTH_MY_CARDS_URL;
        } else if (props.status?.showInviteCodeReferralButton) {
            return AUTH_PROFILE_INVITE + '?showPromoSliders=true';
        } else {
            return AUTH_SEND_MAIN_LINK + '?screen_source=transfer_status';
        }
    };

    const primaryButtonOnClick = (e) => {
        if (showLowRiskLimitIncrease) {
            e.preventDefault();
            setScreen(LOW_RISK_UPGRADE_LIMIT_SCREEN);
        } else if (props.status?.showUpgradeLimitPromo) {
            e.preventDefault();
            setScreen(REACHING_LIMIT_SCREEN);
        }
    };

    // temporary switch off
    const isShowNotifyRecipient = false; //props.smsOnSuccessPay && !props.smsOnSuccessPay.sended && props.showSendSMSNotificationBlock;

    const renderScreen = (currentScreen) => {
        switch (currentScreen) {
            case REACHING_LIMIT_SCREEN:
                return <PromoReachingLimit primaryButtonOnClick={() => setScreen(UPGRADE_LIMIT_SCREEN)} />;
            case LOW_RISK_UPGRADE_LIMIT_SCREEN:
                return <PromoLowRiskUpgradeLimit modalRef={props.modalRef} />;
            case UPGRADE_LIMIT_SCREEN:
                return <PromoUpgradeLimit />;
            default:
                return (
                    <PromoInfoPage
                        animatedIconSuccess
                        hasBorder={!!isShowNotifyRecipient}
                        headerText={headerTitle}
                        secondaryText={<DangerouslyHtml dangerouslyHtml={statusText} />}
                        buttonRowCaption={isShowNotifyRecipient ? statusSmsTitle : null}
                        primaryButtonCaption={statusDoneTitle}
                        primaryButtonType="link"
                        primaryButtonLink={getPrimaryButtonLink()}
                        primaryButtonOnClick={primaryButtonOnClick}
                    />
                );
        }
    };

    return renderScreen(screen);
};
Success.propTypes = {
    modalRef: PropTypes.object.isRequired,
    status: PropTypes.object.isRequired,
    smsOnSuccessPay: PropTypes.object,
    showSendSMSNotificationBlock: PropTypes.bool,
};

export default Success;
